import { useEffect, useState } from "react"
import './ToAlipay.less'
import { _authAlipay } from '../../api/user'
import { Toast } from "dingtalk-design-mobile"
import dd from '@/utils/dd.config'


const ToAlipay = () => {
  // const [authCode, setAuthCode] = useState('')
  useEffect(() => {
    if(window.location.href.indexOf("auth_code") !== -1){
      const url = new URL(window.location.href)
      const paramsStr = url.search.slice(1)
      const params = new URLSearchParams(paramsStr)
      const code = params.get('auth_code') || ''
      const token = params.get('token') || ''
      // setAuthCode(token)
      // return
      localStorage.setItem('TOKEN', token)
      _authAlipay({ code }).then(res => {
        const [ d, result ] = res
        if (d && result) {
          Toast.success({
            content: '授权成功',
          })
          // setAuthCode(result)
          // 跳转企业码
          window.location.replace('alipays://platformapi/startapp?appId=2021002128690179&page=/pages/staff/index/index?accountId%3D2088340610787578%26path%3D%2Fpages%2Fstaff%2Fpayment-code%2Findex%3FaccountId%3D2088340610787578')
        }
      })

    }
  }, [])
  return (
    <div className='pg-toAlipay--wrap'>
      {/* <div>用户未登录</div> */}
      {/* <div>{ authCode }</div> */}
    </div>
  )
}

export default ToAlipay